import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import DeferredButton from '@/components/parts/catalog/card/components/defer';
import { ACTION_ADD, ACTION_REMOVE, Item, Items } from '@/store/deferred';
import { SAVE, SAVED } from './const';

const CARD = 'event_card';
const DEFERRED = 'deferred';
const deferred = namespace(DEFERRED);
const card = namespace(CARD);

@Component({
  components: { DeferredButton },
})
export default class PageEventCardButtonDeferred extends Vue {
  // Vuex
  @card.State id: Item['id'];
  @card.State('url_code') code: Item['code'];
  @card.State('name') title: Item['title'];
  @card.State('age_group_text') age: Item['age'];
  @card.State('available_order_current_year')
  available_order_current_year: Item['available_order_current_year'];
  @card.State('available_order_next_year')
  available_order_next_year: Item['available_order_next_year'];
  @card.State image: any;
  @card.State('announce') note: Item['note'];

  @deferred.State items: Items;
  @deferred.State ready: boolean;
  @deferred.Action(ACTION_ADD) add: (item: Item) => void;
  @deferred.Action(ACTION_REMOVE) remove: (id: Item['id']) => void;

  // Computed
  get saved() {
    return this.items.findIndex((item) => item.id === this.id) >= 0;
  }

  get text() {
    return this.saved ? SAVED : SAVE;
  }

  // Methods
  toggle() {
    const {
      id,
      code,
      title,
      age,
      image,
      note,
      saved,
      available_order_next_year,
      available_order_current_year,
    } = this;

    if (saved) return this.remove(id);

    // const { big = '', little = '' } = image || {};
    const imageToPush = {
      small: image.little,
      large: image.big,
    };
    this.add({
      id,
      code,
      title,
      age,
      image: imageToPush,
      note,
      available_order_next_year,
      available_order_current_year,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/event/card/button-deferred/script.ts